import { render, staticRenderFns } from "./ModalOnceReply.vue?vue&type=template&id=3fc82dac&scoped=true&"
import script from "./ModalOnceReply.vue?vue&type=script&lang=js&"
export * from "./ModalOnceReply.vue?vue&type=script&lang=js&"
import style0 from "./ModalOnceReply.vue?vue&type=style&index=0&id=3fc82dac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc82dac",
  null
  
)

export default component.exports